module.exports = __webpack_public_path__ + "bell-8e5d34c8afbcb6113a53981b3e7eebdb.png";